module.exports = __webpack_public_path__ + "static/media/grocery-product-3.de78b002.png";